import React from 'react';

export const LockBadge: React.FC<React.PropsWithChildren<unknown>> = () => null;
